import {
  SHOP_CORE_SORT_OPTIONS,
  SortDirection,
} from "api/requests/consumerApi/searchShopCoreMenuItems";

import Dropdown from "components/botanic/Dropdown";
import DropdownItem from "components/botanic/Dropdown/DropdownItem";

export type SortState = {
  sort: SHOP_CORE_SORT_OPTIONS;
  sortDirection: SortDirection;
};

const SHOP_CORE_SORT_LABEL_MAP: { [key: string]: SortState | null } = {
  "Delivery fee": {
    sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_FEE,
    sortDirection: "asc",
  },
  "Delivery minimum": {
    sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_MINIMUM,
    sortDirection: "asc",
  },
  "Delivery time": {
    sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_TIME,
    sortDirection: "asc",
  },
  Distance: {
    sort: SHOP_CORE_SORT_OPTIONS.PICKUP_DISTANCE,
    sortDirection: "asc",
  },
  "Price: high to low": {
    sort: SHOP_CORE_SORT_OPTIONS.PRICE,
    sortDirection: "desc",
  },
  "Price: low to high": {
    sort: SHOP_CORE_SORT_OPTIONS.PRICE,
    sortDirection: "asc",
  },
  Recommended: null,
  "THC: high to low": {
    sort: SHOP_CORE_SORT_OPTIONS.THC,
    sortDirection: "desc",
  },
  "THC: low to high": {
    sort: SHOP_CORE_SORT_OPTIONS.THC,
    sortDirection: "asc",
  },
};

const getLabelForSortState = (sortState: SortState | null): string => {
  if (!sortState) {
    return "Recommended";
  }

  const sortConfig = Object.entries(SHOP_CORE_SORT_LABEL_MAP).find(
    ([_label, labelSortState]) =>
      labelSortState?.sort === sortState.sort &&
      labelSortState?.sortDirection === sortState.sortDirection
  );

  return sortConfig ? sortConfig[0] : "";
};

const ShopCoreSort = ({
  selectedSort,
  onChange,
  isDeliveryAvailable = true,
}: {
  selectedSort: SortState | null;
  onChange: (newVal: SortState | null) => void;
  isDeliveryAvailable?: boolean;
}) => {
  return (
    <div
      data-testid="sort-dropdown"
      className="flex flex-shrink-0 items-center justify-center text-xs ml-lg"
    >
      Sort by&nbsp;
      <Dropdown
        className="items-center"
        selectedItem={getLabelForSortState(selectedSort)}
      >
        <DropdownItem
          key="recommended"
          className="p-md z-10"
          onClick={() => onChange(null)}
        >
          Recommended
        </DropdownItem>
        {isDeliveryAvailable ? (
          <>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.DELIVERY_TIME}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_TIME,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_TIME,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.DELIVERY_FEE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_FEE,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_FEE,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.DELIVERY_MINIMUM}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_MINIMUM,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_MINIMUM,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.PRICE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.PRICE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                  sortDirection: "desc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                sortDirection: "desc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.THC}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.THC,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.THC,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.THC}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.THC,
                  sortDirection: "desc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.THC,
                sortDirection: "desc",
              })}
            </DropdownItem>
          </>
        ) : (
          <>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.PICKUP_DISTANCE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.PICKUP_DISTANCE,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.PICKUP_DISTANCE,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.PRICE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.PRICE}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                  sortDirection: "desc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.PRICE,
                sortDirection: "desc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.THC}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.THC,
                  sortDirection: "asc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.THC,
                sortDirection: "asc",
              })}
            </DropdownItem>
            <DropdownItem
              key={SHOP_CORE_SORT_OPTIONS.THC}
              className="p-md z-10 whitespace-nowrap"
              onClick={() =>
                onChange({
                  sort: SHOP_CORE_SORT_OPTIONS.THC,
                  sortDirection: "desc",
                })
              }
            >
              {getLabelForSortState({
                sort: SHOP_CORE_SORT_OPTIONS.THC,
                sortDirection: "desc",
              })}
            </DropdownItem>
          </>
        )}
      </Dropdown>
    </div>
  );
};

export default ShopCoreSort;
